<template lang="pug">
  v-autocomplete.hidden-sm-and-down(
    class="unified-header-global-search"
    data-cy="contact-search"
    solo
    flat
    clearable
    no-filter
    ref='search'
    prepend-inner-icon='search'
    :search-input.sync='localSearch'
    :items='searchItems'
    label='Search contacts'
    :loading='isLoading'
    @input='redirect'
  )
    template(slot='item' slot-scope='{ item }')
      v-list-tile-content(@click.stop='redirect(item)' data-cy="contact-search-item")
        v-list-tile-title(v-text='contactText(item)')
      template(v-if='isARecentSearch(item)')
        v-list-tile-action
          v-btn(icon ripple @click.stop='removeRecentSearch(item)')
            v-icon clear
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { debounce, prepareRequest } from '@/Core/utilities';

export default {
  name: 'ContactSearch',
  data() {
    return {
      localSearch: null,
    };
  },
  computed: {
    ...mapState({
      error: state => state.contactsSearch.error,
      search: state => state.contactsSearch.search,
      isLoading: state => state.contactsSearch.isLoading,
      searchResults: state => state.contactsSearch.searchResults,
      recentSearches: state => state.contactsSearch.recentSearches,
    }),
    ...mapGetters('contactsSearch', ['searchItems']),
    ...mapGetters('userInformation', ['userHasFeatureFlag'])
  },
  watch: {
    /**
     * Watcher on the search value. Key branch to understand is the first, if
     * the search is cleared then we clear our search results too.
     *
     * @param  {String} value the search string
     * @return {}
     */
    localSearch(value) {
      if (!value) {
        this.setSearchResults([]);
      } else {
        debounce(prepareRequest, [value, this.searchContacts]);
      }
    },
  },
  methods: {
    ...mapActions('contactsSearch', ['searchContacts', 'resetSearchResults']),
    ...mapMutations('contactsSearch', [
      'setSearch',
      'setRecentSearch',
      'setSearchResults',
      'removeRecentSearch',
    ]),
    isARecentSearch(item) {
      return item.recentSearch;
    },
    hasSearches(recentSearches) {
      return recentSearches.length;
    },
    /**
     * Redirect to the contact profile page.
     * - Sets the recent search to what was entered
     * - Blurs the autocomplete
     * - Emits update:search which calls a redirect using $Router.push
     *
     * @param  {Integer} id the id of the contact
     * @return {}
     */
    redirect(data) {
      if (data.id) {
        const recentSearch = {
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email || data.email_primary,
          recentSearch: true,
        };
        this.setRecentSearch(recentSearch);
        this.resetSearchResults();
        this.$refs.search.blur();
        this.$emit('update:search', data.id);
      }
    },
    contactText(item) {
      return `${item.first_name} ${item.last_name} (${item.email || item.email_primary})`;
    },
  },
};
</script>

<style scoped>
  .v-select-list >>> .v-subheader {
    color: #9CA3AF !important;
  }
</style>